let ProtectApp = (function ($) {
  return {
    init: function () {
      const self = this;
      this.menu();
      this.subMenuToggle();

      // this.aboutSlider();
      // this.howItWorksSlider();

      $("html").animate(
        {
          scrollTop: 0,
        },
        0,
        function () {
          setTimeout(function () {
            self.animationTrigger();

            // if (navigator.platform.toUpperCase().indexOf("MAC") == -1) {
            //   self.smoothScroll();
            // }
          }, 500);
        }
      );
    },
    menu: function (id) {
      $("[data-menu]").on("click", function () {
        $(".site-header").toggleClass("opened");
        $(".site-header__button").toggleClass("opened");
        $(".site-header__menu").toggleClass("opened");
        $(".site-header__shadow").toggleClass("opened");
      });
    },
    subMenuToggle: function () {
      $(".menu-item-has-children > button.arrow").on("click", function (e) {
        var width = $(window).width();

        if (width < 768) {
          e.preventDefault();
          $(this).parent().find(".sub-menu").first().slideToggle(500);
        }
      });

      var resizeFunction = function () {
        var width = $(window).width();

        if (width > 767) $(".sub-menu").removeAttr("style");
      };

      var timeout = null;
      $(window).on("resize", function () {
        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(resizeFunction, 50);
      });
    },

    animationTrigger: function () {
      $(document).ready(function () {
        var elements = $(".animation-trigger");
        var windowHeight = $(window).height();
        elements.each(function (index) {
          if (windowHeight > $(this).offset().top) {
            $(this).addClass("animate");
          }
        });
        $(window).on("scroll", onScroll);
        $(document.body).on("touchmove", onScroll);

        var resizeFunction = function () {
          windowHeight = $(window).height();
        };

        var timeout = null;
        $(window).on("resize", function () {
          if (timeout) clearTimeout(timeout);

          timeout = setTimeout(resizeFunction, 50);
        });

        function onScroll() {
          var yScrollPos = $(window).scrollTop();
          elements.each(function (index) {
            if (
              yScrollPos + windowHeight * 0.8 > $(this).offset().top &&
              !$(this).hasClass("animate")
            ) {
              $(this).addClass("animate");
            }
          });
        }
      });
    },

    smoothScroll: function () {
      const math = {
        lerp: (a, b, n) => {
          return (1 - n) * a + n * b;
        },
        norm: (value, min, max) => {
          return (value - min) / (max - min);
        },
      };

      const config = {
        height: window.innerHeight,
        width: window.innerWidth,
      };

      class Smooth {
        constructor() {
          this.bindMethods();

          this.data = {
            ease: 0.1,
            current: 0,
            last: 0,
            rounded: 0,
          };

          this.dom = {
            el: document.querySelector("[data-scroll]"),
            content: document.querySelector("[data-scroll-content]"),
          };

          this.rAF = null;

          this.init();
        }

        bindMethods() {
          ["scroll", "run", "resize"].forEach(
            (fn) => (this[fn] = this[fn].bind(this))
          );
        }

        setStyles() {
          Object.assign(this.dom.el.style, {
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            overflow: "hidden",
          });
        }

        setHeight() {
          document.body.style.height = `${
            this.dom.content.getBoundingClientRect().height
          }px`;
        }

        resize() {
          this.setHeight();
          this.scroll();
        }

        preload() {
          imagesLoaded(this.dom.content, (instance) => {
            this.setHeight();
          });
        }

        scroll() {
          this.data.current = window.scrollY;
        }

        run() {
          this.data.last +=
            (this.data.current - this.data.last) * this.data.ease;
          this.data.rounded = Math.round(this.data.last * 100) / 100;

          const diff = this.data.current - this.data.rounded;
          const acc = diff / config.width;
          const velo = +acc;
          const skew = velo * 7.5;

          this.dom.content.style.transform = `translate3d(0, -${this.data.rounded}px, 0) skewY(${skew}deg)`;

          this.requestAnimationFrame();
        }

        on() {
          this.setStyles();
          this.setHeight();
          this.addEvents();

          this.requestAnimationFrame();
        }

        off() {
          this.cancelAnimationFrame();

          this.removeEvents();
        }

        requestAnimationFrame() {
          this.rAF = requestAnimationFrame(this.run);
        }

        cancelAnimationFrame() {
          cancelAnimationFrame(this.rAF);
        }

        destroy() {
          document.body.style.height = "";

          this.data = null;

          this.removeEvents();
          this.cancelAnimationFrame();
        }

        resize() {
          this.setHeight();
          this.data.rounded = this.data.last = this.data.current;
        }

        addEvents() {
          window.addEventListener("resize", this.resize, { passive: true });
          window.addEventListener("scroll", this.scroll, { passive: true });
        }

        removeEvents() {
          window.removeEventListener("resize", this.resize, { passive: true });
          window.removeEventListener("scroll", this.scroll, { passive: true });
        }

        init() {
          this.preload();
          this.on();
        }
      }

      new Smooth();
    },

    aboutSlider: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".about-powered-by");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider
          .slick({
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            swipeToSlide: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,
          })
          .on("beforeChange", function (e, s, c, n) {
            $(this)
              .parent()
              .find("[data-slide-number]")
              .text(n + 1 < 10 ? "0" + (n + 1) : n + 1);
          });
      }
    },
    howItWorksSlider: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".how-it-works");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider
          .slick({
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            swipeToSlide: true,
            slidesToShow: 1,
            arrows: false,
            dots: true,
          })
          .on("beforeChange", function (e, s, c, n) {
            console.log(n);
            $(this)
              .parent()
              .find("[data-slide-number]")
              .text(n + 1 < 10 ? "0" + (n + 1) : n + 1);
          });
      }
    },
  };
})(jQuery);

(function ($) {
  $(window).on("elementor/frontend/init", function () {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/protectapp-about-powered-by.default",
      function ($scope) {
        ProtectApp.aboutSlider($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/protectapp-how-it-works.default",
      function ($scope) {
        ProtectApp.howItWorksSlider($scope.context.dataset.id);
      }
    );
  });

  $(ProtectApp.init());
})(jQuery);
